export const fmtDA = (n) => {
  const v = Number(n || 0);
  return (
    new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(v) + " DA"
  );
};

export const fmtInt = (n) =>
  new Intl.NumberFormat("fr-FR").format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const MODES_LABEL = {
  especes: "Espèces",
  banque: "Banque",
  virement: "Virement",
  cheque: "Chèque",
  carte: "Carte bancaire",
  autre: "Autre",
};

export const STATUT_FACTURE = {
  a_payer: { label: "À payer", cls: "bg-muted text-muted-foreground" },
  non_payee: { label: "Non payée", cls: "bg-muted text-muted-foreground" },
  partiellement_payee: { label: "Partiellement payée", cls: "bg-warning/15 text-warning" },
  payee: { label: "Payée", cls: "bg-success/15 text-success" },
  en_retard: { label: "En retard", cls: "bg-destructive/15 text-destructive" },
  annule: { label: "Annulée", cls: "bg-muted text-muted-foreground line-through" },
};

export const STATUT_BCF = {
  valide: { label: "Validé", cls: "bg-accent text-accent-foreground" },
  partiellement_recu: { label: "Partiellement reçu", cls: "bg-warning/15 text-warning" },
  recu: { label: "Reçu", cls: "bg-success/15 text-success" },
  cloture: { label: "Clôturé", cls: "bg-muted text-muted-foreground" },
  annule: { label: "Annulé", cls: "bg-muted text-muted-foreground line-through" },
};

export const ROLES_LABEL = {
  administrateur: "Administrateur",
  direction: "Direction",
  comptabilite: "Comptabilité",
  commercial: "Commercial",
  magasinier: "Magasinier",
  production: "Production",
  consultation: "Consultation",
};
